import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiclient";

const MealPlansTable = (id) => {
  const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;

  const restaurantId = id.id;
  const [data, setData] = useState([]);
  const [menuMap, setMenuMap] = useState({});
  const [menuFormMap, setMenuFormMap] = useState({});
const [editingId, setEditingId] = useState(null);
const [expandedMainId, setExpandedMainId] = useState(null);
const [editPrice, setEditPrice] = useState({
  id: null,
  price: ""
});
const handlePriceChange = (id, value) => {
  setEditPrice({
    id,
    price: value
  });
};
const handleSavePrice = async () => {
  try {
    const payload = {
      editMealPLanSubTypeListList: [
        {
          id: editPrice.id,
          price: Number(editPrice.price)
        }
      ]
    };

    await apiClient.put("/mealplan/edit", payload);
setData(prev =>
      prev.map(item =>
        item.id === editPrice.id
          ? { ...item, price: Number(editPrice.price) }
          : item
      )
    );
    alert("Updated successfully");
  } catch (e) {
    console.error(e);
  }
};
  const flattenMealPlans = (data) => {
    let result = [];

    data.forEach((main) => {
      main.mealPlans.forEach((plan) => {
        result.push({
          mealplanmainid: main.mealplanmainid,
          mealplanname: main.mealplanname,
          ...plan,
        });
      });
    });

    return result;
  };

  const groupedData = data.reduce((acc, item) => {
    const existingGroup = acc.find(
      (group) => group.mealplanmainid === item.mealplanmainid
    );

    if (existingGroup) {
      existingGroup.plans.push(item);
    } else {
      acc.push({
        mealplanmainid: item.mealplanmainid,
        mealplanname: item.mealplanname,
        plans: [item],
      });
    }

    return acc;
  }, []);

  const normalizeMenuData = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (payload && typeof payload === "object") return [payload];
    return [];
  };

  const dayLabels = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get(`/mealplan/${restaurantId}`);
        const flatData = flattenMealPlans(res.data);
        setData(flatData);

        const uniqueMainIds = [...new Set(flatData.map(d => d.mealplanmainid))];

        const menuData = {};
        const initialMenuFormData = {};

        await Promise.all(
          uniqueMainIds.map(async (id) => {
            try {
              const res = await apiClient.get(`/subscriptionmenu/${id}`);
              const normalizedMenus = normalizeMenuData(res.data);
              menuData[id] = normalizedMenus;
              initialMenuFormData[id] = normalizedMenus;
            } catch (e) {
              menuData[id] = [];
              initialMenuFormData[id] = [];
            }
          })
        );

        setMenuMap(menuData);
        setMenuFormMap(initialMenuFormData);
      } catch (e) {
        console.error(e);
      }
    };

    fetchData();
  }, []);

  const handleMenuChange = (mainId, menuIndex, field, value) => {
    setMenuFormMap((prev) => ({
      ...prev,
      [mainId]: (prev[mainId] || []).map((menu, index) =>
        index !== menuIndex
          ? menu
          : {
              ...menu,
              [field]: value,
            }
      ),
    }));
  };

  const handleSetDefault = (mainId, menuIndex) => {
    setMenuFormMap((prev) => ({
      ...prev,
      [mainId]: (prev[mainId] || []).map((menu, index) => ({
        ...menu,
        isDefault: index === menuIndex,
      })),
    }));
  };

  const createEmptyMenu = () => ({
    lunch: Array(7).fill("") ,
    dinner: Array(7).fill(""),
    isDefault: false,
  });

  const handleAddMenu = (mainId) => {
    setMenuFormMap((prev) => ({
      ...prev,
      [mainId]: [...(prev[mainId] || []), createEmptyMenu()],
    }));
  };

  const refreshMenuData = async (mainId) => {
    const res = await apiClient.get(`/subscriptionmenu/${mainId}`);
    const normalizedMenus = normalizeMenuData(res.data);
    setMenuMap((prev) => ({ ...prev, [mainId]: normalizedMenus }));
    setMenuFormMap((prev) => ({ ...prev, [mainId]: normalizedMenus }));
  };

  const handleSaveMenu = async (mainId, menuIndex) => {
    try {
      const menu = (menuFormMap[mainId] || [])[menuIndex];
      if (!menu) return;

      const payload = {
        lunch: (menu.lunch || []).filter(Boolean),
        dinner: (menu.dinner || []).filter(Boolean),
        isDefault: Boolean(menu.isDefault),
      };

      if (menu.id) {
        await apiClient.put(`/subscriptionmenu/${menu.id}`, payload);
      } else {
        await apiClient.post(`/subscriptionmenu/${mainId}`, payload);
      }

      await refreshMenuData(mainId);
      alert("Menu saved successfully");
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="space-y-4">
      {groupedData.length === 0 ? (
        <div className="text-gray-500 mt-4">No meal plans available.</div>
      ) : (
        groupedData.map((group) => (
          <div
            key={group.mealplanmainid}
            className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm"
          >
            <div className="bg-gray-100 px-4 py-3 flex flex-wrap items-center justify-between gap-2">
              <div>
                <h3 className="font-semibold text-gray-800">{group.mealplanname}</h3>
                <p className="text-sm text-gray-500">Main ID: {group.mealplanmainid}</p>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                  {group.plans.length} plan(s)
                </span>
                <button
                  onClick={() =>
                    setExpandedMainId(
                      expandedMainId === group.mealplanmainid ? null : group.mealplanmainid
                    )
                  }
                  className="bg-blue-500 text-white px-3 py-1 rounded"
                >
                  {expandedMainId === group.mealplanmainid ? "Hide Menu" : "View Menu"}
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="bg-gray-50 text-left">
                    <th className="px-3 py-2">Plan ID</th>
                    <th className="px-3 py-2">Days</th>
                    <th className="px-3 py-2">Plan Name</th>
                    <th className="px-3 py-2">Type</th>
                    <th className="px-3 py-2">Price</th>
                    <th className="px-3 py-2">Per Day</th>
                    <th className="px-3 py-2">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {group.plans.map((item) => (
                    <React.Fragment key={item.id}>
                      <tr className="border-t">
                        <td className="px-3 py-2">{item.id}</td>
                        <td className="px-3 py-2">{item.days}</td>
                        <td className="px-3 py-2">{item.planName}</td>
                        <td className="px-3 py-2">{item.mealPlanType?.name}</td>
                        <td className="px-3 py-2">
                          {editingId === item.id ? (
                            <input
                              type="number"
                              value={editPrice.id === item.id ? editPrice.price : item.price}
                              onChange={(e) => handlePriceChange(item.id, e.target.value)}
                              className="border w-20 text-center"
                            />
                          ) : (
                            Number(item.price || 0).toFixed(2)
                          )}
                        </td>
                        <td className="px-3 py-2">{Number(item.perdayprice || 0).toFixed(2)}</td>
                        <td className="px-3 py-2">
                          <div className="flex flex-wrap gap-2">
                            {editingId === item.id ? (
                              <button
                                onClick={() => {
                                  handleSavePrice();
                                  setEditingId(null);
                                }}
                                className="bg-blue-600 text-white px-2 py-1 rounded"
                              >
                                Save
                              </button>
                            ) : (
                              isAdmin && (
                                <button
                                  onClick={() => {
                                    setEditingId(item.id);
                                    setEditPrice({ id: item.id, price: item.price });
                                  }}
                                  className="bg-yellow-500 text-white px-2 py-1 rounded"
                                >
                                  Edit
                                </button>
                              )
                            )}
                          </div>
                        </td>
                      </tr>

                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>

            {expandedMainId === group.mealplanmainid && (
              <div className="border-t bg-gray-50 p-4">
                <div className="flex justify-end mb-4">
                  <button
                    onClick={() => handleAddMenu(group.mealplanmainid)}
                    className="bg-indigo-600 text-white px-3 py-1 rounded"
                  >
                    Add Menu
                  </button>
                </div>
                <div className="space-y-4">
                  {((menuFormMap[group.mealplanmainid] || [])).length === 0 ? (
                    <div className="text-sm text-gray-500">No menus available for this meal plan.</div>
                  ) : (
                    (menuFormMap[group.mealplanmainid] || []).map((menuItem, menuIndex) => (
                      <div
                        key={menuItem.id || `${group.mealplanmainid}-${menuIndex}`}
                        className={`border rounded-md p-3 ${menuItem.isDefault ? "border-blue-500 bg-blue-50" : "bg-white"}`}
                      >
                        <div className="flex items-center justify-between gap-4 mb-3">
                          <div>
                            <h4 className="font-semibold text-gray-800">Menu {menuIndex + 1}</h4>
                            {menuItem.isDefault && (
                              <span className="text-xs bg-blue-500 text-white px-2 py-1 rounded-full">
                                Default
                              </span>
                            )}
                          </div>
                          <div className="text-xs text-gray-500">ID: {menuItem.id ?? "new"}</div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <div className="mb-2 text-sm font-medium text-gray-700">Lunch</div>
                            <div className="space-y-2">
                              {dayLabels.map((day, dayIndex) => (
                                <div key={day} className="flex items-center gap-2">
                                  <div className="w-20 text-xs font-semibold text-gray-600">{day.slice(0,3)}</div>
                                  <input
                                    type="text"
                                    value={(menuItem.lunch?.[dayIndex] || "")}
                                    onChange={(e) =>
                                      handleMenuChange(
                                        group.mealplanmainid,
                                        menuIndex,
                                        "lunch",
                                        dayLabels.map((_, index) =>
                                          index === dayIndex
                                            ? e.target.value.trim()
                                            : menuItem.lunch?.[index] || ""
                                        )
                                      )
                                    }
                                    className="flex-1 border px-2 py-1 text-sm"
                                  />
                                </div>
                              ))}
                            </div>
                          </div>

                          <div>
                            <div className="mb-2 text-sm font-medium text-gray-700">Dinner</div>
                            <div className="space-y-2">
                              {dayLabels.map((day, dayIndex) => (
                                <div key={day} className="flex items-center gap-2">
                                  <div className="w-20 text-xs font-semibold text-gray-600">{day.slice(0,3)}</div>
                                  <input
                                    type="text"
                                    value={(menuItem.dinner?.[dayIndex] || "")}
                                    onChange={(e) =>
                                      handleMenuChange(
                                        group.mealplanmainid,
                                        menuIndex,
                                        "dinner",
                                        dayLabels.map((_, index) =>
                                          index === dayIndex
                                            ? e.target.value.trim()
                                            : menuItem.dinner?.[index] || ""
                                        )
                                      )
                                    }
                                    className="flex-1 border px-2 py-1 text-sm"
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div className="mt-4 flex flex-wrap gap-2 justify-end">
                          <button
                            onClick={() => handleSetDefault(group.mealplanmainid, menuIndex)}
                            className={`px-3 py-1 rounded ${menuItem.isDefault ? "bg-gray-300 text-gray-700" : "bg-blue-600 text-white"}`}
                          >
                            {menuItem.isDefault ? "Default" : "Set as Default"}
                          </button>
                          <button
                            onClick={() => handleSaveMenu(group.mealplanmainid, menuIndex)}
                            className="bg-green-600 text-white px-3 py-1 rounded"
                          >
                            Save Menu
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default MealPlansTable;